import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Checkbox, Grid, Link, Typography } from '@emburse/ui-core';
export const SignUpTerms = ({ checked, error, onChange, whitelabelName, partner_id }) => {
    const getLinks = () => {
        var _a, _b, _c, _d;
        const links = [
            {
                href: (_b = (_a = window.whitelabelConfiguration) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.termsOfService,
                text: (whitelabelName === 'Emburse Spend' ? 'Emburse' : whitelabelName) + ' Terms'
            }
        ];
        if (partner_id === 'amex') {
            links.push({
                href: window.whitelabelConfiguration.tags.termsOfServiceAmex,
                text: 'American Express Terms'
            });
        }
        links.push({
            href: (_d = (_c = window.whitelabelConfiguration) === null || _c === void 0 ? void 0 : _c.tags) === null || _d === void 0 ? void 0 : _d.privacyPolicy,
            text: 'Privacy Policy'
        });
        return links;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Grid, Object.assign({ container: true, alignItems: 'center' }, { children: [_jsx(Grid, { children: _jsx(Checkbox, { className: error ? 'errorRed' : '', color: "primary", checked: checked, name: "tos_accepted", required: true, onChange: () => onChange(!checked), style: { marginRight: 5 } }) }), _jsx(Grid, Object.assign({ item: true, sm: true }, { children: _jsxs(Typography, Object.assign({ variant: "body2" }, { children: ["By activating your account, you agree to the", ' ', getLinks().map((link, index, array) => {
                                    return (_jsxs(_Fragment, { children: [_jsx(Link, Object.assign({ href: link.href, target: "_blank", underline: "none" }, { children: link.text })), index < array.length - 2 && ', ', index === array.length - 2 && ', and '] }));
                                })] })) }))] })), error && (_jsx(Typography, Object.assign({ variant: "caption", className: "errorRed", sx: { paddingLeft: '50px' } }, { children: "* Please accept the terms and conditions" })))] }));
};
